import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

import { useGetWaitListStatus } from '~entities/studios/api/get-wait-list-status';
import { useUpdateWaitListStatus } from '~entities/studios/api/update-wait-list-status';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Label } from '~shared/shadcn/ui/label';
import { Switch } from '~shared/shadcn/ui/switch';

export function TrialBookingsSettings() {
  const { data: waitListStatus, isLoading: isLoadingStudio } =
    useGetWaitListStatus();
  const updateWaitListStatus = useUpdateWaitListStatus();

  const studioEnabled = Boolean(waitListStatus?.trialBookingEnabled);

  const handleUpdateTrialBookingStatus = async (status: boolean) => {
    try {
      await updateWaitListStatus.mutateAsync({
        trialBookingEnabled: status,
      });
      toast.success(
        `Trial booking ${status ? 'enabled' : 'disabled'} successfully`,
      );
    } catch {
      toast.error(`Error ${status ? 'enabling' : 'disabling'} trial booking`);
    }
  };

  return (
    <div className='p-4'>
      <Link to='/dashboard' className='mb-8 flex items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back to Dashboard</span>
      </Link>

      <Card className='mx-auto max-w-4xl'>
        <CardHeader>
          <CardTitle>Trial Bookings</CardTitle>
          <CardDescription>
            Turn studio-wide Trial Booking on or off. Class-level Trial Booking
            and calendar setup stay on each class under Book Trial Class →
            Settings.
          </CardDescription>
        </CardHeader>
        <CardContent className='space-y-6'>
          <div className='rounded-lg border bg-card p-5'>
            <div className='flex items-start justify-between gap-4'>
              <div className='space-y-1'>
                <Label htmlFor='studio-trial-booking' className='text-sm'>
                  Studio-wide Trial Booking
                </Label>
                <p className='text-xs text-muted-foreground'>
                  This is the studio gate. Parents cannot book trials while this
                  is off.
                </p>
              </div>
              <Switch
                id='studio-trial-booking'
                checked={studioEnabled}
                disabled={isLoadingStudio || updateWaitListStatus.isPending}
                onCheckedChange={(checked) => {
                  void handleUpdateTrialBookingStatus(checked);
                }}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
